const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const ProjectActions = Reflux.createActions({
    getAllProjects: { children: ['completed', 'failed'] },
    createProject: { children: ["completed", "failed"] },
    archiveProject: { children: ["completed", "failed"] },
    renameProject: { children: ["completed", "failed"] },
    updateProjectDescription: { children: ["completed", "failed"] },
    copyProject: { children: ["completed", "failed"] },
    transferProject: { children: ["completed", "failed"] },
    getProjectTags: { children: ["completed", "failed"] },
    addProjectTag: { children: ["completed", "failed"] },
    addProjectTags: { children: ["completed", "failed"] },
    deleteProjectTag: { children: ["completed", "failed"] },
});

ProjectActions.getAllProjects.listen(function(actionId) {
    const self = this;

    ServerRequest.makeRequest('/authoring/projects_v2', 'GET')
        .then(res => self.completed(actionId, res))
        .catch(err => self.failed(actionId, err));
});

ProjectActions.createProject.listen(function(actionId, params) {
    if (!params.name) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    const body = {
        name: params.name,
    };

    if (params.folderId) {
        body.folder_id = params.folderId;
    }

    if (params.contentType) {
        body.content_type = params.contentType;
    }

    ServerRequest.makeRequest(`/authoring/channels/${params.channelId}/projects/create`, 'POST', JSON.stringify(body))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ProjectActions.archiveProject.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/archive`, 'PUT')
        .then(res => this.completed(actionId, params.projectID, res))
        .catch(err => this.failed(actionId, params.projectID, err));
});

ProjectActions.renameProject.listen(function(actionId, params) {
    const self = this;

    if (!params.name) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/rename`, 'PUT', JSON.stringify({
            name: params.name
        }))
        .then(function(res) { self.completed(actionId, params.projectID, params.name, res); })
        .catch(function(err) { self.failed(actionId, err); });
});

ProjectActions.updateProjectDescription.listen(function(actionId, params) {
    if (typeof params.description !== 'string') {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/description`, 'PUT', JSON.stringify({
            description: params.description
        }))
        .then(res => this.completed(actionId, params.projectID, params.description, res))
        .catch(err => this.failed(actionId, err));
});

ProjectActions.copyProject.listen(function(actionId, params) {
    const self = this;
    if (!params.name) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectId}/copy`, 'POST', JSON.stringify({
            name: params.name,
            toChannel: params.channelId,
            toFolder: params.folderId,
        }))
        .then(res => self.completed(actionId, res))
        .catch(err => self.failed(actionId, err));
});

ProjectActions.transferProject.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/projects/${params.projectId}/transfer`, 'PATCH', JSON.stringify({
            folder_id: params.folderId || 'root',
        }))
        .then(res => self.completed(actionId, res))
        .catch(err => self.failed(actionId, err));
});

ProjectActions.getProjectTags.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/tag_v2`, 'GET')
        .then(function(res) { self.completed(actionId, params.projectID, res); })
        .catch(function(err) { self.failed(actionId, err); });
});

ProjectActions.addProjectTag.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/tag`, 'PUT', JSON.stringify({
            tag: params.tagRecord.tag
        }))
        .then(function(res) { self.completed(actionId, params.projectID, params.tagRecord, res); })
        .catch(function(err) { self.failed(actionId, err); });
});

ProjectActions.addProjectTags.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/tags`, 'PUT', JSON.stringify({
            tags: params.tagRecords.map(tagRecord => tagRecord.tag),
        }))
        .then(res => self.completed(actionId, params.projectID, params.tagRecords, res))
        .catch(err => self.failed(actionId, err));
});

ProjectActions.deleteProjectTag.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/projects/${params.projectID}/tag`, 'DELETE', JSON.stringify({
            tag: params.tagRecord.tag
        }))
        .then(function(res) { self.completed(actionId, params.projectID, params.tagRecord, res); })
        .catch(function(err) { self.failed(actionId, err); });
});

module.exports = ProjectActions;